import type { FirestoreTimestampField } from '../utils/firestore-timestamp.util';

/**
 * Marketplace / Classified Ads listing document (`listings/{listingId}`).
 * Created by the Resident app; Admin web is read-only for now.
 */
export interface Listing {
  id: string;
  title?: string;
  description?: string;
  price?: number | string | null;
  currency?: string | null;
  propertyId?: string;
  userId?: string;
  userName?: string;
  /** Image download URLs or storage paths (Resident may use images / photos / imageUrls). */
  images?: string[] | null;
  photos?: string[] | null;
  imageUrls?: string[] | null;
  status?: string | null;
  category?: string | null;
  createdOn?: FirestoreTimestampField;
  updatedOn?: FirestoreTimestampField;
  /** Raw Firestore fields retained for the detail page (chat excluded). */
  [key: string]: unknown;
}

/** Fields never shown on the Admin listing detail page. */
export const LISTING_CHAT_FIELD_KEYS = new Set([
  'chat',
  'chatId',
  'chats',
  'messages',
  'messageIds',
  'conversationId',
  'conversation',
]);
